/**
 * Shared colour constants for the failure-cluster map (design doc 015 §6).
 *
 * Per-mode colours are no longer a pure function of the `failure_mode_id` — that
 * hashing scheme collided too often with a handful of modes. They are assigned by
 * `useModeColors` / `assignVisibleSlots` so the modes on screen stay distinct and
 * hold their colour for the session. This module keeps only the palette-agnostic
 * bits: the fixed unassigned grey and the hull-fill helper.
 */

/** Grey used for unassigned failures (the long tail) — never a mode colour. */
export const UNASSIGNED_COLOR = "#94a3b8"; // slate-400

/** Convert `#rrggbb` + alpha → an `rgba(...)` string, for translucent hull fills. */
export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
